import styled from 'styled-components';

export default styled.div`
  position: fixed;
  width: 300px;
  top: 30px;
  left: 30px;
  font-size: 30px;
  font-weight: bold;
  z-index: 2;
  background: white;
  box-shadow: 0 0 10px rgba(0,0,0,0.5);
  padding: 10px;
  border-radius: 5px;
  
  input {
    width: 100%;
  }
`;
